import React, 
{ 
    useEffect,
    useState 
} from 'react'

import toast from 'react-hot-toast';

import { 
    Delete,
    Edit,
} from '@mui/icons-material';

import { 
    Form,
    Input,
    Col, 
    Row,
    Table,
    Space,
    Button,
} from 'antd';

import { usePostRequest } from '../../hooks/usePostRequest'
// import { formatDate } from '../../Utils/Common';

const Locker = ({lockersData, fetchMembersData, isLoading, id}) => {
    const [lockersForm] = Form.useForm();
    const { callPost, loading } = usePostRequest(()=>{
        fetchMembersData();
    });
    const [lockersInfo, setLockersInfo] = useState([])

    const handleDelete = (key) => {
        const newData = [...lockersInfo];
        newData.splice(key, 1); 
        setLockersInfo(() => newData)
    };
      
    const addRow = () => {
        const newData = [...lockersInfo];
        newData.push({
            locker_ids: '',
            descriptions: '',
            isWritable: true,
        });
        setLockersInfo(newData);
    };

    const handleTable = (e, index, name) => {
        const { value } = e.target

        setLockersInfo(prevState => {
            const newState = [...prevState];
                newState[index] = { 
                    ...newState[index],
                    [name]: value
                };
            return newState;
        });
    }

    const handleRowClick = (row_id) => {
        const newData = lockersInfo?.map((item, index) => ({
          ...item,
          isWritable: row_id === index ? !item.isWritable : item.isWritable,
        }));
        setLockersInfo(newData);
    };

    const defaultColumns = [
        {
          title: 'Locker ID',
          dataIndex: 'locker_ids',
          align: 'center',
          key: 'locker_ids',
          width: '25%',
          render: (_, record, index) => (
            record.isWritable ? (
                
                <Input
                    value={record.locker_ids}
                    onChange={(e) => handleTable(e, index, "locker_ids")}
                />
            ) : record.locker_ids
          ),
        },
        {
          title: 'Description',
          dataIndex: 'descriptions',
          align: 'center',
          key: 'descriptions',
          width: '75%',
          render: (_, record, index) => (
            record.isWritable ? (
               
                <Input
                    value={record.descriptions}
                    onChange={(e) => handleTable(e, index, "descriptions")}
                />
            ) : record.descriptions
          ),
        },
        {
            title: '',
            dataIndex: '',
            align: 'center',
            render: (_, record, index) => (
                <Space>
                    {
                        (record.id) && (
                            <div 
                                onClick={() => handleRowClick(index)}
                                className='cursor'
                            >
                                <Edit/>
                            </div>
                        )
                    }
                    <div 
                        onClick={() => handleDelete(index)}
                        className='cursor'
                    >
                        <Delete  
                            style={{
                                color: 'red',
                            }}
                        />
                    </div>
                </Space>
            ),
            onCell: () => ({
                onClick: (e) => {
                e.stopPropagation();
                },
            }),
        },
    ];

    const handleCreateLockers = () => {
        lockersForm.validateFields().then(values => {
            const newValues = {
                member_id: id,
            }

            newValues.id =  lockersInfo?.map((item)=>item.id || "")
            newValues.locker_ids =  lockersInfo?.map((item)=>item.locker_ids || "")
            newValues.descriptions =  lockersInfo?.map((item)=>item.descriptions || "")

            callPost(
                "members/update_locker", 
                newValues,
                false,
            );
        }).catch(errorInfo => {
            toast.error('Validation Failed ', errorInfo);
        });
    };

    const validateArray = (array) => {
        if(array.length === 0){
            return false
        } else {
            return array.every((item) => {
                return item.locker_ids !== "" || item.descriptions !== "";
            });
        }
    };

    useEffect(() => {
        if(lockersData){
            const lockers_data = lockersData?.map((data) => ({
                id: data.id,
                member_id: data.member_id,
                locker_ids: data.locker_id,
                descriptions: data.description,
                added_by: data.added_by,
                added_on: data.added_on,
                updated_by: data.updated_by,
                updated_on: data.updated_on,
                is_deleted: data.is_deleted,
            }))
             
            setLockersInfo(lockers_data)
        }
    }, [lockersData])

    return (
        <Row className='tab-container custom-padding'>
            <Col span={24}>
                <Form 
                    layout="vertical"
                >
                    <Row>
                        <Col span={24} className='responsive-overflow-y'>
                            <Table
                                bordered
                                dataSource={lockersInfo}
                                columns={defaultColumns}
                                pagination={false}
                                loading={isLoading}
                                scroll={{ x: 800 }} 
                            />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-4' >
                        <Col span={24}>
                            <Button 
                                type="primary" 
                                onClick={addRow}
                            >
                                Add Row
                            </Button>
                        </Col>
                    </Row>
                    <Row className='btn-footer'>
                        <Space className='p-2'>
                            <Button
                                onClick={handleCreateLockers}
                                loading={loading}
                                type='primary'
                                disabled={!validateArray(lockersInfo)}
                                className='button-color btn-header'
                            >
                                Save
                            </Button>
                        </Space>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}
export default Locker
